/**
 * RBAC-4.4 — what one person can do, and where each permission comes from.
 *
 * ⚠️ THIS MODULE HOLDS NO RULES. What the rows mean is `lib/personEffectivePermissions.ts`; who may
 * read them, and which permissions the person holds, is the database's (`20261102a7`:
 * roles.administer, the person homed in the caller's current account, and
 * `cost_holds_permission_for()` for every row). Nothing here passes a tenant id.
 */

import { supabase } from '@/lib/supabaseClient';
import {
  PERSON_EFFECTIVE_PERMISSIONS_RPC,
  parsePersonEffectivePermissions,
  type PersonEffectivePermissions,
} from '@/lib/personEffectivePermissions';
import { PersonRoleError } from './personRoleService';

export async function fetchPersonEffectivePermissions(userId: string): Promise<PersonEffectivePermissions> {
  const { data, error } = await supabase.rpc(PERSON_EFFECTIVE_PERMISSIONS_RPC, { p_user_id: userId });
  if (error) throw new PersonRoleError({ message: error.message, code: error.code, hint: error.hint });
  const parsed = parsePersonEffectivePermissions(data);
  if (!parsed) throw new PersonRoleError({ message: "This person's permissions came back in a shape this screen does not read." });
  return parsed;
}
